import {
    BasePlanDetailsSchema,
    PartnersSchema,
    PlanDetailsSchema,
    UserPlansServicesSchema,
    VerifiedPlanDetailsSchema,
} from '../types';
import {z} from 'zod';

export const basePlanDetailsValidator = (value: unknown): boolean =>
    z.array(BasePlanDetailsSchema).safeParse(value).success;

export const unverifiedPlansValidator = (value: unknown): boolean =>
    z.array(PlanDetailsSchema).safeParse(value).success;

export const verifiedPlansValidator = (value: unknown): boolean =>
    z.array(VerifiedPlanDetailsSchema).safeParse(value).success;

export const terminatedPlansValidator = (value: unknown): boolean =>
    z.array(PlanDetailsSchema).safeParse(value).success;

export const filteredPartnersValidator = (value: unknown): boolean => z.array(PartnersSchema).safeParse(value).success;

export const userPlansDetailsValidator = (value: unknown): boolean => UserPlansServicesSchema.safeParse(value).success;
